import { atom } from "jotai";
import { User } from "../models/user.model";

export const authAtom = atom<{
  user: User | null;
  authenticated: boolean;
  loaded: boolean;
}>({
  user: null,
  authenticated: false,
  loaded: false,
});
